import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const BmwLuxuryCars = () => {
  return (
    <>
      <section
        className="page-title"
       style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>BMW Luxury Car Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>BMW 3, 5 & 7 Series Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          Make a bold statement with eTravo’s premium BMW rental services. Whether it's the sporty 3 Series, 
          the executive-class 5 Series, or the ultra-luxurious 7 Series — each BMW is a symbol of performance, 
          prestige, and perfection. Ideal for weddings, VIP transfers, celebrity transport, or corporate events.
        </p>

        <h2 style={styles.subHeader}>Available BMW Series:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>BMW 3 Series:</strong> Sporty, stylish, and perfect for quick getaways or classy city travel.</li>
          <li style={styles.listItem}><strong>BMW 5 Series:</strong> Executive luxury sedan with powerful performance and elite comfort.</li>
          <li style={styles.listItem}><strong>BMW 7 Series:</strong> Ultimate flagship luxury for weddings, VIP movements, and elite experiences.</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Dual-zone climate control & leather interiors</li>
          <li style={styles.listItem}>Advanced infotainment with navigation</li>
          <li style={styles.listItem}>Rear-seat entertainment (7 Series)</li>
          <li style={styles.listItem}>Ambient lighting and soundproof cabins</li>
          <li style={styles.listItem}>Professional chauffeur service</li>
          <li style={styles.listItem}>Daily and hourly rental options</li>
        </ul>

        <h2 style={styles.subHeader}>Best For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Wedding Car Rentals</li>
          <li style={styles.listItem}>Airport VIP Transfers</li>
          <li style={styles.listItem}>Corporate Guest Pickup</li>
          <li style={styles.listItem}>Luxury City Tours</li>
          <li style={styles.listItem}>Red Carpet & Event Arrivals</li>
        </ul>

        <h2 style={styles.subHeader}>Why Book with eTravo?</h2>
        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we understand luxury. Our fleet is impeccably maintained and delivered with trained chauffeurs, 
          punctual service, and complete discretion. From booking to arrival, we offer a seamless luxury travel experience.
        </p>

 

        <h2 style={styles.subHeader}>Reserve Your BMW Now</h2>
        <p style={styles.paragraph}>
          Let your next journey be a luxurious one. Contact <strong>eTravo</strong> today to book a BMW and
          elevate your ride experience with our trusted premium car rental services.
        </p>
      </div>
    </>
  );
};

export default BmwLuxuryCars;
